import React, { useState, useEffect } from "react";

function BannerText() {
  const [display, setDisplay] = useState([]);
  const [index, setIndex] = useState(0);

  //Banner text animation
  useEffect(() => {
    const texts = [
      "Frontend Developer",
      "UI/UX Designer",
      "Analytics",
      "SEO Optimization",
      "Responsive Design",
      "Web Design",
    ];

    let i = 0;

    const timer = setInterval(() => {
      setDisplay(
        texts.map((text, mapIndex) => {
          if (index === mapIndex) {
            return text.substring(0, i);
          }
          return "";
        })
      );
      i++;
      if (i > texts[index].length) {
        clearInterval(timer);
        setTimeout(() => {
          let j = texts[index].length;
          const timer2 = setInterval(() => {
            setDisplay(
              texts.map((text, mapIndex) => {
                if (index === mapIndex) {
                  return text.substring(0, j);
                }
                return "";
              })
            );
            j--;
            if (j < 0) {
              clearInterval(timer2);
              setTimeout(() => {
                // Reset index to the next text in the array
                setIndex((index + 1) % texts.length);
                i = 0;
              }, 1000);
            }
          }, 150);
        }, 1000);
      }
    }, 150);
  }, [index]);

  return (
    <div className="banner-text">
      <div className="text-wrapper">
        {display.map((text, mapIndex) => (
          <h1 key={mapIndex} className="alertText">
            {text}
          </h1>
        ))}
      </div>
    </div>
  );
}

export default BannerText;
